import React, { useState } from "react";
import style from "../forget-password/forgetPassword.module.css";
import styles from "./updatePassword.module.css"
import getFetchConfig from '../../utils/getFetchConfig';
import standardFetchHandlers from '../../utils/standardFetchHandlers';
import handleFetchErrors from '../../utils/handleFetchErrors';
import PasswordChecklistComponent from "../password-checklist/PasswordChecklist";
import LoaderButton from "../buttons/loader-button/LoaderButton";
import Inputs from "../Inputs/Inputs";
import { isValidPassword } from "../../utils/verification";
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import appURLs from "../../appURL";

import { isTruthyString, isValidEmailAddress, isValidIndianMobileNumber } from '../../utils/verification';

export default function UpdatePassword({ email_address = null, updateModalVisibilityForUpdatePassword = null, updateModalVisibilityForForgetPassword = null }) {


    const navigate = useNavigate();
    const fetchConfig = getFetchConfig();

    const appURL = appURLs();


    const [passwordInputTypeForNewPassword, updatePasswordInputTypeForNewPassword] = useState(`password`),
        [passwordInputTypeForConfirmPassword, updatePasswordInputTypeForConfirmPassword] = useState(`password`);

    const [showLoader, toggleLoader] = useState(false),
        [formData, updateFormData] = useState({

            password: '',
            confirm_password: '',
        });

    const { password, confirm_password } = formData;

    const onChangeHandlerForFormData = (e) => {
        const inputName = e?.target?.name || e?.name,
            inputValue = e?.target?.value || e?.value;

        updateFormData((prev) => ({
            ...prev,
            [inputName]: inputValue
        }));
    };


    const passwordInputChangeHandler = (inputTpe, source) => {

        if (source === 1) updatePasswordInputTypeForNewPassword(inputTpe);
        else if (source === 2) updatePasswordInputTypeForConfirmPassword(inputTpe);

    }



    const onSubmitHandler = async (e) => {
        e.preventDefault();
        toast.dismiss();


        const missingData = [],
            invalidData = [];


        if (!email_address) missingData.push(`email address`);
        else if (email_address && !isValidEmailAddress(email_address)) invalidData.push(`email address`);

        if (!password) missingData.push(`password`);
        else if (password && !isValidPassword(password)) invalidData.push(`Please enter valid password`);

        if (!confirm_password) missingData.push(`password confirmation`);


        // Show errors if needed
        if (missingData.length || invalidData.length) {
            if (missingData.length) toast.error(`Missing: ${missingData.join(`, `)}`);
            if (invalidData.length) toast.error(`Invalid: ${invalidData.join(`, `)}`);
            return;
        }

        

        fetch(`${appURL}/update-password`, {
            ...fetchConfig,
            body: JSON.stringify({ email_address, newPassword: password })
        })
            .then(handleFetchErrors)
            .then((res) => {



                if (res?.status === 200) {
                    updateModalVisibilityForForgetPassword(false)
                    updateModalVisibilityForUpdatePassword(false)
                    return toast.success(res?.message);
                } else if (res?.status === 400) {
                    return toast.error(res?.message)
                } else {
                    return toast.error(`Something isn't working right`);
                }

            }).catch(standardFetchHandlers.error)
            .finally(() => {
                setTimeout(() => {
                    toggleLoader(false);
                }, 1000);
            });
    };


    return (

        <>

            <main>


                <form onSubmit={onSubmitHandler} >

                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Password</label>
                        <div className={styles.password_input_wrapper}>
                            <input type={passwordInputTypeForNewPassword} value={password} onChange={onChangeHandlerForFormData} className="form-control" name='password' placeholder="Enter your new password" autoComplete="off" />
                            {
                                passwordInputTypeForNewPassword === "text" ?
                                    <svg onClick={() => { passwordInputChangeHandler(`password`, 1) }} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                    : <svg onClick={() => { passwordInputChangeHandler(`text`, 1) }} fill="#000000" width="20" height="20" viewBox="0 -16 544 544" xmlns="http://www.w3.org/2000/svg" ><title>hide</title><path d="M108 60L468 420 436 452 362 378Q321 400 272 400 208 400 154 361 99 322 64 256 79 229 102 202 124 174 144 160L76 92 108 60ZM368 256Q368 216 340 188 312 160 272 160L229 117Q254 112 272 112 337 112 392 152 446 192 480 256 474 269 461 288 448 307 434 322L368 256ZM272 352Q299 352 322 338L293 309Q283 312 272 312 249 312 233 296 216 279 216 256 216 247 220 236L190 206Q176 229 176 256 176 296 204 324 232 352 272 352Z" /></svg>
                            }

                        </div>
                        {
                            password && password.length > 0 ?
                                <PasswordChecklistComponent
                                    password={password}
                                    rules= {["minLength", "specialChar", "number", "capital", "lowercase"]}
                                    confirm_password={confirm_password}
                                /> : ``

                        }
                    </div>

                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Confirm Password*</label>
                        <div className={styles.password_input_wrapper}>
                            <input type={passwordInputTypeForConfirmPassword} onChange={onChangeHandlerForFormData} className="form-control" name='confirm_password' placeholder="Re-enter your password" autoComplete="off" />
                            {
                                passwordInputTypeForConfirmPassword === "text" ?
                                    <svg onClick={() => { passwordInputChangeHandler(`password`, 2) }} xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                                    :
                                    <svg onClick={() => { passwordInputChangeHandler(`text`, 2) }} fill="#000000" width="20" height="20" viewBox="0 -16 544 544" xmlns="http://www.w3.org/2000/svg" ><title>hide</title><path d="M108 60L468 420 436 452 362 378Q321 400 272 400 208 400 154 361 99 322 64 256 79 229 102 202 124 174 144 160L76 92 108 60ZM368 256Q368 216 340 188 312 160 272 160L229 117Q254 112 272 112 337 112 392 152 446 192 480 256 474 269 461 288 448 307 434 322L368 256ZM272 352Q299 352 322 338L293 309Q283 312 272 312 249 312 233 296 216 279 216 256 216 247 220 236L190 206Q176 229 176 256 176 296 204 324 232 352 272 352Z" /></svg>
                            }

                        </div>

                        {
                            confirm_password && confirm_password.length ?
                   
                               <PasswordChecklistComponent
                                    password={password}
                                    rules={[ "match"]}
                                    confirm_password={confirm_password}
                                /> 
                         
                       :``
                        }

                    </div>
                    {
                        showLoader ?
                            <LoaderButton /> :
                            <div id={style.submit_btn} className="form-group">
                                <button type="submit" className="btn btn-confirm">
                                    Confirm
                                </button>

                            </div>


                    }

                </form>
            </main>
        </>
    )
}